export default __webpack_public_path__ + "static/media/06.55968c67.jpg";